///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import tableSelection from "../../../helpers/tableSelection";
import LanesGridRow from "./LanesGridRow";

export const LanesGridBody = ({
  lanes,
  columns,
  offset,
  perPage,
  role,
  columnOrder,
  disableDeleteButton,
  matchingLaneRequestLaneId,
  isLaneMatch = false,
  handlePaste,
  userDivision,
  bidDivision,
  analyticsGridView = false,
  onRowClick,
  selectedRowIndex,
  selectedButtonIndex,
  isCoyoteBid,
  isServerPaged = false
}) => {
  const matched = lanes.filter(lane => lane.metaData.matched);
  const lanesToRender = isServerPaged
    ? matched
    : matched.slice(offset, offset + perPage);
  return (
    <tbody
      onCopy={tableSelection.handleCopy}
      onKeyDown={tableSelection.handleKeyDown}
    >
      {lanesToRender.map((lane, index) => (
        <LanesGridRow
          key={lane.metaData.defaultIndex}
          columnOrder={columnOrder}
          lane={lane}
          rowIndex={index}
          columns={columns}
          role={role}
          disableDeleteButton={disableDeleteButton}
          matchingLaneRequestLaneId={matchingLaneRequestLaneId}
          isLaneMatch={isLaneMatch}
          rowCount={lanes.length}
          numberOfRowsRendered={lanesToRender.length}
          handlePaste={handlePaste}
          userDivision={userDivision}
          bidDivision={bidDivision}
          analyticsGridView={analyticsGridView}
          onRowClick={onRowClick}
          selectedRowIndex={selectedRowIndex}
          selectedButtonIndex={selectedButtonIndex}
          isCoyoteBid={isCoyoteBid}
        />
      ))}
    </tbody>
  );
};

export default LanesGridBody;
